export const getDateTimeRecord = () => {
  const now = new Date();
  const UTC = now.toISOString();
  let offset: string | number = -(now.getTimezoneOffset() / 60);
  if (offset >= 0) offset = "+" + offset;
  else offset = offset.toString();

  const pad = (n: number) => String(n).padStart(2, "0");
  const lt = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
    now.getDate(),
  )}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

  return {
    utc: UTC,
    tz: offset,
    lt,
  };
};
